import { render, staticRenderFns } from "./RegionalHighlight.vue?vue&type=template&id=6b09aeba&scoped=true"
import script from "./RegionalHighlight.vue?vue&type=script&lang=js"
export * from "./RegionalHighlight.vue?vue&type=script&lang=js"
import style0 from "./RegionalHighlight.vue?vue&type=style&index=0&id=6b09aeba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b09aeba",
  null
  
)

export default component.exports